import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'customDate', standalone: true })

export class CustomDatePipe implements PipeTransform {
  /**
   * @description Convierte string ISO o dd/MM/yyyy a objeto Date para la vista.
   * @param value El string de fecha a convertir.
   * @return El objeto Date correspondiente o null si el formato es incorrecto.
   */
  transform(value: any): Date | null {
    if (!value) return null;

    if (typeof value === 'string' && value.includes('T')) {
      const date = new Date(value);
      const day = date.getUTCDate().toString().padStart(2, '0');
      const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
      const year = date.getUTCFullYear();

      const result = new Date(+year, +month - 1, +day);
      return result;
    }
    if (typeof value === 'string' && value.includes('/')) {
      const parts = value.split('/');
      return new Date(+parts[2], +parts[1] - 1, +parts[0]);
    }

    return null;
  }
}
